import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Fade,
  Grid,
  Modal,
  Typography,
  Button,
  Checkbox,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./OrderQueueCard.css";
import imageCross from "./../../../../assets/icons/cross.png";
import axios from "axios";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import closeIcon from "./../../../../assets/icons/close.png";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { toast, ToastContainer } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const OrderQueueCard = (props) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [currentStatus, setCurrentStatus] = useState(0);
  const [selectItem, setSelecttedItem] = useState(false);
  const [cencalationReasons, setCencalationReasons] = useState(false);
  const [selectCencalationReason, setSelectCencalationReason] = useState(false);
  const [remarks, setRemarks] = useState("N/A");

  console.log(props);

  useEffect(() => {
    switch (props.from) {
      case "Ready":
        setCurrentStatus(7);
      case "Pending":
        setCurrentStatus(5);
      case "Preparing":
        setCurrentStatus(6);
      case "Queue":
        setCurrentStatus(1);
    }
  }, []);

  const handleCancelItem = async (item) => {
    setSelecttedItem(item);
    handleOpen();
    await loadCancelationReasons();
  };

  const loadCancelationReasons = async () => {
    await axios
      .get(`${process.env.REACT_APP_SECRET}/api/OrderCancelationReason`)
      .then((res) => {
        var list = [];
        res.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.cancelationReason,
          };
          list.push(obj);
        });
        setCencalationReasons(list);
      });
  };

  const handleCancelOrder = async () => {
    var obj = {
      id: "string",
      orderItemId: selectItem.id,
      statusId: "IS006",
      isRefunded: true,
      cancelationReasonId:
        selectCencalationReason.id != undefined
          ? selectCencalationReason.id
          : "CR007",
      cancelationReason:
        selectCencalationReason.title != undefined
          ? selectCencalationReason.title
          : "Not Provided",
      remarks: remarks,
      restaurantId: props.restaurantId,
    };
    await axios
      .post(`${process.env.REACT_APP_SECRET}/api/Order/CancelOrderItem`, obj)
      .then((res) => {
        toast.success("Item successfully canceled", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        handleClose();
        props.reload();
      });
  };
  const handleStatusChange = async (isChecked, selectedItemId) => {
    var obj = {
      id: "string",
      orderItemId: selectedItemId,
      statusId: isChecked ? "IS007" : "IS008",
      restaurantId: props.restaurantId,
    };
    await axios
      .post(`${process.env.REACT_APP_SECRET}/api/Order/ChangeOrderStatus`, obj)
      .then((res) => {
        toast.success("Item Status Changed", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        props.reload();
      });

    // if (props.from == "Preparing") {
    //   handleStatusChange(
    //     !props.ItemDetails.isReady,
    //     props.ItemDetails.id
    //   );}
  };
  const truncateItemName = (name) => {
    return name.length > 18 ? `${name.substring(0, 18)}...` : name;
  };
  return (
    <>
      <ToastContainer />
      {/* FoodItems Detail Section */}
      <div
        className="row"
        title={
          props.from === "Preparing"
            ? "dblclick to send to ready"
            : "dblclick to send back to preparing"
        }
        style={{
          padding: "10px",
          backgroundColor: props.ItemDetails.isReady ? "#66bb6a" : "initial",
          cursor: "pointer",
        }}
        onDoubleClick={() => {
          if (props.from == "Preparing") {
            handleStatusChange(
              !props.ItemDetails.isReady,
              props.ItemDetails.id
            );
          } else if (props.from === "Ready") {
            handleStatusChange(
              !props.ItemDetails.isReady,
              props.ItemDetails.id
            );
          }
        }}
      >
        <div className="col-10 d-flex justify-content-start align-items-center">
          <Tooltip title={props.ItemDetails.itemName} arrow>
            <Typography
              className="orderQueueCardItemName"
              sx={{
                color: props.ItemDetails.isReady ? "white !important" : "black",
              }}
            >
              {props.index + 1}.{" "}
              {props.fromData == "Modal"
                ? props.ItemDetails.itemName
                : truncateItemName(props.ItemDetails.itemName)}
            </Typography>
          </Tooltip>
        </div>
        <div className="col-2 d-flex justify-content-end align-items-center orderQty">
          <Typography
            className="orderQueueCardItemName"
            sx={{
              color: props.ItemDetails.isReady ? "white !important" : "black",
            }}
          >
            x{props.ItemDetails.qty}
          </Typography>
          {props.from != "Ready" && (
            <img
              src={imageCross}
              className="crossImage"
              onClick={() => {
                handleCancelItem(props.ItemDetails);
                console.log("Cross Clicked", props.ItemDetails);
              }}
            />
          )}
          {props.isWaitersView == false &&
            (props.from == "Preparing" || props.from == "Ready") && (
              <Checkbox
                color={props.ItemDetails.isReady ? "default" : "success"}
                checked={props.ItemDetails.isReady}
                onChange={(event) => {
                  handleStatusChange(
                    event.target.checked,
                    props.ItemDetails.id
                  );
                }}
              />
            )}
          {/* {props.ItemDetails.isReady && props.from != "Preparing" && (
            <Checkbox
              color={props.ItemDetails.isReady ? "default" : "success"}
              checked={props.ItemDetails.isReady}
              onChange={(event) => {
                handleStatusChange(event.target.checked, props.ItemDetails.id);
              }}
            />
          )} */}
        </div>
        {/* AddOns Mapping */}
        {props.ItemDetails.orderAddons?.length > 0 &&
          props.ItemDetails.orderAddons?.map((addOn, i) => (
            <div className="col-12 d-flex flex-wrap">
              <span
                className="orderQueueCardAddOnName"
                style={{
                  color: props.ItemDetails.isReady
                    ? "white !important"
                    : "black",
                }}
              >
                {addOn?.addOnName} x{addOn?.qty}
              </span>
              {/* Option Mapping */}

              {addOn?.orderOptions?.map((item, idx) => (
                <span key={idx} className="orderQueueCardAddOnName">
                  <span style={{ fontSize: "14px" }}>• </span>
                  {item?.optionName} x{item?.qty}
                </span>
              ))}
              {/* SubOption Mapping  */}
              {addOn?.orderOptions?.map((item, idx) =>
                item?.orderSubOptions?.map((subOption, subIdx) => (
                  <span className="orderQueueCardAddOnName" key={subIdx}>
                    <span style={{ fontSize: "14px" }}>• </span>
                    {subOption.subOptionName}
                  </span>
                ))
              )}
            </div>
          ))}
        <div className="col-12">
          <Typography
            className="orderQueueCardInstruction"
            sx={{
              color: props.ItemDetails.isReady ? "white !important" : "black",
            }}
          >
            <b>Instructions: </b>
            {props.ItemDetails.instructions}
          </Typography>
        </div>
      </div>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              ...style,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>GoTaste:- Cancel Items</h5>
              <Button onClick={handleClose}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>
            <br />
            <Grid container>
              <Grid
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  marginTop: ".8rem",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <Typography sx={{ marginBottom: ".5rem" }}>
                  Item Name:
                </Typography>
              </Grid>
              <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                <Typography>
                  <strong>
                    {selectItem.itemName} X {selectItem.qty}
                  </strong>
                </Typography>
              </Grid>
              <Grid
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  marginTop: ".8rem",
                  alignItems: "start",
                  justifyContent: "start",
                }}
              >
                <Typography sx={{ marginBottom: ".5rem" }}>Add Ons:</Typography>
              </Grid>
              <Grid xs={12} md={8} sx={{ marginTop: ".8rem" }}>
                {selectItem.orderAddons?.length > 0 ? (
                  selectItem.orderAddons?.map((option, i) => (
                    <Typography className="">
                      {option.addOnName} x {option.qty}
                    </Typography>
                  ))
                ) : (
                  <Typography>N/A</Typography>
                )}
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <AutoCompleteMultiSelect
                  id={33}
                  placeholder={"Select Cancelation Reason (Optional)"}
                  datas={cencalationReasons}
                  value={(res) => {
                    setSelectCencalationReason(res);
                  }}
                />
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <TextAreaComponents
                  id={1}
                  value={(res) => {
                    setRemarks(res);
                    console.log("remarks", remarks);
                  }}
                  label={"Remarks (Optional)"}
                />
              </Grid>
              <Grid
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "1rem",
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    handleCancelOrder();
                  }}
                >
                  Cancel Item
                </Button>
                <Button variant="outlined" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default OrderQueueCard;
